import { withTranslation } from "react-i18next";

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
class SecondNav extends Component {

    // constructor(props){
    //     super(props)
    // }

    render() {
        return (
            <div>
                <div fixed="top">
                    <div className="second-nav-border" >
                        <div className="row">
                            <div className="col-md-12 row">
                                {/* <table style={{width: "100%"}}>
                                    <tbody>
                                        <tr>
                                            <td className="pointer">
                                                Home
                                            </td>
                                            <td className="pointer" style={{width: "24%"}}>
                                                Introductory Text
                                            </td>
                                            <td className="pointer">
                                                Portfolio
                                            </td>
                                            <td>
                                                Listing service
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> */}
                                <div className="col-md-3" style={{ textAlign: "center" }}>
                                    <Link style={{ color: "#777272" }} to={{
                                        pathname: `/seller-edit-profile`,
                                    }}>
                                        {this.props.t('3')}
                                    </Link>
                                </div>
                                <div className="col-md-3" style={{ textAlign: "center" }}>
                                    <Link style={{ color: "#777272" }} to={{
                                        pathname: `/seller-edit-intro`,
                                    }}>
                                        {this.props.t('2')}
                                    </Link>
                                </div>
                                <div className="col-md-3" style={{ textAlign: "center" }}>
                                    <Link style={{ color: "#777272" }} to={{
                                        pathname: `/seller-edit-portfolio`,
                                    }}>
                                        {this.props.t('0')}
                                    </Link>
                                </div>
                                <div className="col-md-3" style={{ textAlign: "center" }}>
                                    <Link style={{ color: "#777272" }} to={{
                                        pathname: `/service-list`,
                                    }}>
                                        {this.props.t('1')}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { SecondNav };

 SecondNav = withTranslation('src_Components_Common_SecondNav')(SecondNav);